class ApiFactory {
    static $inject = ['$http'];

    /** @param {ng.IHttpService} $http */
    constructor($http) {
        this.create = url => {
            return {
                all: () => $http.get(url).then(/** @returns {[]} */ r => r.data),
                get: (id) => $http.get(`${url}/${id}`).then(r => r.data),
                create: (entity) => $http.post(url, entity).then(r => r.data),
                update: (id, entity) => $http.put(`${url}/${id}`, entity).then(r => r.data),
				delete: (id) => $http.delete(`${url}/${id}`).then(r => r.data)				
            }
        }
    }
}

angular
    .module('app')
    .service('apiFactory', ApiFactory);
